import React from 'react';
import { useTheme, Box, Tooltip, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { SAC_STATE_COLORS } from '../models/sacConfig';
import { useAuth } from '../context/provider';
import { useNavigate } from "react-router-dom";

const SacChatHeader = ({ sac }) => {
	const navigate = useNavigate();
	const { setCurrSubpage } = useAuth();
	const theme = useTheme();

	const handleSacNameClick = () => {
		navigate(`/sac?id=${sac.id}`);
		setTimeout(() => {
			setCurrSubpage('loadSacGeneral');
		}, 500); // Delay to ensure navigation is complete
	};
	
	const getStateValue = (state) => {
		if (!sac.sac_state_all) return '';
		const stateObj = sac.sac_state_all.find((s) => s.key === state);
		return stateObj ? stateObj.value : '';
	};

	const getStateStyle = (state) => {
		const backgroundColor = SAC_STATE_COLORS[state] || '#000';
		return { backgroundColor, color: '#fff', width: 'auto' };
	};

	const isOverdue = (sac, dateLimit) => {
		return sac.sac_state < 300 && new Date() > new Date(dateLimit);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				marginLeft: theme.spacing(0),
				marginBottom: theme.spacing(1),
				padding: theme.spacing(0.5),
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Add shadow here
				width: '100%',
				position: 'relative', // Ensure shadow is positioned correctly
				zIndex: 1, // Ensure shadow is above scrolling content
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center', // Center text and status
					justifyContent: 'center',
					marginTop: theme.spacing(1),
				}}
			>
				<Typography
					onClick={handleSacNameClick}
					sx={{
						fontSize: 18,
						fontWeight: 600,
						color: theme.palette.primary.main,
						textAlign: 'center',
						cursor: 'pointer', // Make it clear that this is clickable
						'&:hover': {
							textDecoration: 'underline',
						},
					}}
				>
					{ sac.sac_name }
				</Typography>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: theme.spacing(1),
						marginTop: theme.spacing(0.5),
					}}
				>
					<Typography
						sx={{
							fontSize: 14,
							color: theme.palette.text.secondary,
							textAlign: 'center',
						}}
					>
						{ sac.sac_sender_name }
					</Typography>
					<Box
						sx={{
							borderRadius: theme.shape.borderRadius,
							padding: theme.spacing(0.5, 1),
							backgroundColor: getStateStyle(sac.sac_state).backgroundColor,
							color: theme.palette.common.white,
							fontSize: 12,
							textAlign: 'center',
						}}
					>
						{ getStateValue(sac.sac_state) }
					</Box>
					{ isOverdue(sac, sac.sac_date_limit) && (
						<Tooltip title="Diese Aktivität ist überfällig">
							<AccessTimeIcon
								sx={{
									color: theme.palette.error.main,
									fontSize: 16,
								}}
							/>
						</Tooltip>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default SacChatHeader;
